module.exports = __webpack_public_path__ + "static/img/2023_9_8_8.4671a5e9.4671a5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_8.4671a5e9.jpg
// module id = gQDC
// module chunks = 0